import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CloudinaryImageService extends ServiceBase {

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }

  /**
   * Headers for a multipart upload: the Bearer token, and deliberately NO
   * `Content-Type`.
   *
   * `ServiceBase.RequestHeaders()` cannot be used here — it sets
   * `Content-Type: application/json`, which on a `FormData` body suppresses the
   * browser-generated multipart boundary and the server cannot parse the parts.
   * So the token is applied the same way, minus that header.
   *
   * Every method in this service previously omitted `Authorization` entirely. There
   * is no `HttpInterceptor` in this app — auth is per-call via `ServiceBase` — so
   * nothing supplied it downstream and every upload in the application returned 401.
   */
  private multipartHeaders(extra: Record<string, string> = {}): { headers: HttpHeaders } {
    const token = this.authService.getAccessToken();
    const base: Record<string, string> = { 'Accept': 'application/json', ...extra };
    if (token) {
      base['Authorization'] = 'Bearer ' + token;
    }
    return { headers: new HttpHeaders(base) };
  }

  public uploadImage(formData: FormData): Observable<string> {
    const httpOptions = this.multipartHeaders({ 'enctype': 'multipart/form-data' });
    const api: string = '/Upload';
    const method: string = '/single';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<string>(url, formData, httpOptions);
  }

 
  public uploadIFile(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('ImageFile', file); // Note: Using 'ImageFile' as the field name

    // withCredentials is retained (the refresh token is an HTTP-only cookie); the
    // Bearer token is what actually authorises the call.
    const httpOptions = {
      ...this.multipartHeaders(),
      withCredentials: true
    };

    const api: string = '/Upload';
    const method: string = '/file';
    const url: string = environment.BASE_API_PATH + api + method;
    
    return this.http.post<string>(url, formData, httpOptions);
  }


  public uploadImages(formData: FormData): Observable<string[]> {
    const httpOptions = this.multipartHeaders();

    const api: string = '/upload';
    const method: string = '/multi';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<string[]>(url, formData, httpOptions);
  }
}